import * as React from 'react';
import cx from 'classnames';
import get from 'lodash/get';
import { chatBlobIoClientId } from 'constants/AppConstants';
import { AsyncStatus } from 'utils/asyncStatusHelper';
import { getBlobUrl } from 'actions/ApiCaller';
import StringWidget, { stringTemplate } from 'components/StringWidget/StringWidget';
import { ImageThumbnail } from 'components/FileUpload';
import MessageMeta, { MessageMetaTheme } from 'components/MessageMeta/MessageMeta';
import placeholderImg from 'images/placeholder.svg';
import imageUploadErrorIcon from 'images/chat/image-upload-error-icon.svg';
import styles from './ChatImage.css';
export default class ChatImage extends React.Component {
    constructor(props) {
        super(props);
        this.retryUpload = file => () => {
            if (typeof this.props.retryUpload === 'function') {
                this.props.retryUpload(file);
            }
        };
        this.state = {
            loaded: false
        };
    }
    componentDidMount() {
        const serverPath = get(this.props, 'data.serverPath');
        const resourceId = get(this.props, 'data.resourceId');
        if (!serverPath && !resourceId) {
            return;
        }
        const resourceUrl = resourceId ? `https://blobio.flipkart.net/v3/blobio/sc?resourceId=${resourceId}` : serverPath;
        getBlobUrl(resourceUrl, {
            headers: {
                'X-Flipkart-Client': chatBlobIoClientId
            }
        }).then(src => {
            this.setState({
                src,
                loaded: true
            });
        });
    }
    render() {
        const { isReceivedMessage, timeStamp, messageStatus, file } = this.props;
        const { loaded, src } = this.state;
        const showOverlay = (loaded && !file) || (file && file.asyncStatus === AsyncStatus.SUCCESS);
        return (<div className={cx(cx(styles['chat-image-container'], {
            [styles['sent-message']]: !isReceivedMessage,
            [styles['received-message']]: isReceivedMessage
        }))}>
				<div className={cx({ [styles['image-placeholder']]: !loaded && !file }, styles['chat-image'])}>
					{showOverlay && <div className={styles['image-overlay']}/>}
					{!file ? (<img className={styles['image']} src={loaded ? src : placeholderImg}/>) : (<ImageThumbnail className={cx(styles['image'], styles['image-upload-in-progress'])} srcFile={file.file}/>)}
					{file && file.asyncStatus === AsyncStatus.ERROR && (<div className={styles['image-upload-error-icon-container']}>
							<img className={styles['image-upload-error-icon']} src={imageUploadErrorIcon}/>
						</div>)}
					{file &&
            (file.asyncStatus === AsyncStatus.INIT ||
                file.asyncStatus === AsyncStatus.LOADING ||
                file.asyncStatus === AsyncStatus.ERROR) && (<div className={styles['image-upload-overlay']}>
								<span className={styles['image-upload-progress']} style={{ transform: `scaleX(${(file.progress / 100).toFixed(2)})` }}/>
							</div>)}
					{(!file || file.asyncStatus === AsyncStatus.SUCCESS) && (<MessageMeta lastReadMessageTimestamp={this.props.lastReadMessageTimestamp} lastDeliveredMessageTimestamp={this.props.lastDeliveredMessageTimestamp} theme={showOverlay ? MessageMetaTheme.LIGHT : MessageMetaTheme.DARK} className={styles['message-meta']} isReceivedMessage={isReceivedMessage} timeStamp={timeStamp} messageStatus={messageStatus}/>)}
				</div>
				{file && (file.asyncStatus === AsyncStatus.LOADING || file.asyncStatus === AsyncStatus.ERROR) && (<div className={styles['image-upload-status']}>
						{file && file.asyncStatus === AsyncStatus.LOADING && (<StringWidget strKey="chatImageUploadUploading" className={styles['upload-in-progress']}/>)}
						{file && file.asyncStatus === AsyncStatus.ERROR && (<div className={styles['upload-error']}>
								{stringTemplate('chatImageUploadUploadFailed')}
								<StringWidget strKey="chatImageUploadRetryUpload" className={styles['retry-upload']} onClick={this.retryUpload(file)}/>
							</div>)}
					</div>)}
			</div>);
    }
}
